<template>
  <div>
    <div v-if="!dataLoaded" class="mt20">
      <van-skeleton title avatar :row="6" />
      <p />
      <van-skeleton title avatar :row="6" />
      <p />
      <van-skeleton title avatar :row="6" />
      <p />
    </div>
    <div v-else>
      <div class="pm70">
        <!-- Navbar -->
        <div class="pd jhnstop row" v-if="showNavbar">
          <p class="col">
            <img src="../assets/img/logo.png" class="loginnhjer cz" />
          </p>
          <span class="cf fz15" @click="toHome"> 首页 </span>
        </div>
        <!-- 预约成功 -->
        <div class="pd mt20" v-if="orderInfo.orderStatusName == '已审核'">
          <div class="sdfsdtywer cen pm15">
            <div
              class="mt10"
              style="display: flex;
                    flex-wrap: nowrap;
                    align-items: center;
                    justify-content: center;"
            >
              <img
                src="../assets/img/sucess.png"
                style="width: 30px; height: 30px"
              /><span class="fz24">&nbsp;&nbsp;预约成功</span>
            </div>
            <!-- <div class="pd mt10 fz20" style="font-weight: 400">
              <p>预约成功</p>
            </div> -->
            <div class="mt10 fz16" style="color: red">
              <p
                v-if="
                  (buyerType == 1 || buyerType == 2) &&
                    (orderInfo.keYuanTypeName == '外宾' ||
                      orderInfo.waiBinFlag ||
                      buyerType == 2)
                "
              >
                凭一维码到现场自助设备核验取票
              </p>
              <div v-else>
                <p class="fz24 b">&nbsp;&nbsp;请刷身份证入馆！</p>
                <p class="fz14 b">
                  <nobr>(支持第三代社保卡/电子社保卡/电子市民码)</nobr>
                </p>
              </div>
            </div>
            <!-- <div class="pd mt10">
              <p>
                <span class="fz14 z6">如有疑问，请点击首页【获取帮助】</span>
              </p>
              <p>
                <span class="fz14 z6">查看“预约门票常见问题答疑”</span>
              </p>
            </div> -->
          </div>
        </div>
        <!-- 入馆凭证 -->
        <div v-if="orderInfo.tickets.length > 0">
          <!-- 团体或非实名 显示订单号 外宾-->
          <van-collapse
            v-model="activeTicketName"
            accordion
            class="mt20 sdfsdyywer pd"
            v-if="
              (buyerType == 1 || buyerType == 2) &&
                (orderInfo.keYuanTypeName == '外宾' ||
                  orderInfo.waiBinFlag ||
                  buyerType == 2)
            "
          >
            <!-- v-if="buyerType==1 || buyerType==2"  -->
            <!-- @change="onAccordionChange"> -->
            <van-collapse-item :name="orderInfo.listNo">
              <template #title="title">
                <div class="dian check">
                  <div>
                  <span class="jjnnjxer fz14"> 1 </span>
                  <span class="fz14 z3 ml5">入馆凭证</span>
                  <span class="ml5 fz14 z3">
                    {{ orderInfo.listNo }}
                  </span>
                  </div>
                  <div>
                    <span class="ml5 fz14 z3" v-if="orderInfo.listNo==activeTicketName">
                      折叠
                    </span>
                    <span class="ml5 fz14 z3" v-else>
                      展开
                    </span>
                  </div>
                </div>
              </template>
              <div class="cen">
                <p>
                  <!-- v-if="orderInfo.keYuanTypeName=='外宾' || orderInfo.waiBinFlag || buyerType==2" -->
                  <vueBarcode
                    v-bind:value="orderInfo.listNo"
                    width="1"
                    height="50"
                    displayValue="false"
                  ></vueBarcode>
                  <span style="color: red"
                    >请持相关证件到现场自助设备找工作人员核验取票</span
                  >
                </p>
                <p v-if="orderInfo.tickets[0].completed">已用完</p>
                <p v-else-if="orderInfo.tickets[0].used">已用</p>
              </div>
              <div style="color:red;">
                <p class="fz14 cen">
                  17:00停止预约，停止入场（暑假期间：17:30停止预约，停止入场）。
                </p>
              </div>
            </van-collapse-item>
          </van-collapse>
          <!-- 团体或非实名 显示订单号 非外宾-->
          <van-collapse
            v-model="activeTicketName"
            accordion
            class="mt20 sdfsdyywer pd"
            v-if="
              (buyerType == 1 || buyerType == 2) &&
                !(
                  orderInfo.keYuanTypeName == '外宾' ||
                  orderInfo.waiBinFlag ||
                  buyerType == 2
                )
            "
          >
            <!-- @change="onAccordionChange"> -->
            <van-collapse-item :name="orderInfo.listNo">
              <template #title="title">
                <div class="dian check">
                  <div>
                  <span class="jjnnjxer fz14"> 1 </span>
                  <span class="fz14 z3 ml5">入馆凭证</span>
                  <span class="ml5 fz14 z3">
                    {{ orderInfo.listNo }}
                  </span>
                  </div>
                  <div>
                    <span class="ml5 fz14 z3" v-if="orderInfo.listNo==activeTicketName">
                      折叠
                    </span>
                    <span class="ml5 fz14 z3" v-else>
                      展开
                    </span>
                  </div>
                </div>
              </template>
              <div class="cen">
                <div>
                  <img :src="orderInfo.tickets[0].qrcode" class="kjnmjmxeert" />
                  <p v-if="orderInfo.tourists.length > 0">
                    <span style="color: red"
                      >凭预约时二代身份证，可直接检票入馆</span
                    >
                  </p>
                  <p v-else><span style="color: red">凭二维码检票入馆</span></p>
                </div>

                <p v-if="orderInfo.tickets[0].completed">已用完</p>
                <p v-else-if="orderInfo.tickets[0].used">已用</p>
              </div>
              <div style="color:red;">
                <p class="fz14 cen">
                  17:00停止预约，停止入场（暑假期间：17:30停止预约，停止入场）。
                </p>
              </div>
            </van-collapse-item>
          </van-collapse>
          <van-collapse
            v-model="activeTicketName"
            class="mt20 sdfsdyywer pd"
            accordion
            v-if="buyerType != 1 && buyerType != 2"
          >
            <!-- @change="onAccordionChange"> -->
            <van-collapse-item
              v-for="(ticket, index) in orderInfo.tickets"
              :key="index"
              :name="ticket.ticketCode"
              class="mt20"
            >
              <template #title="title">
                <div class="dian check">
                  <div>
                  <span class="jjnnjxer fz14">
                    {{ index + 1 }}
                  </span>
                  <span class="fz14 z3 ml5">入馆凭证：扫描二维码检票入馆</span>
                  <!-- <span
                    class="f_b fz12 cf yj4 sdfgdgttwe ml5"
                    v-if="ticket.buyerType"
                    >{{ ticket.buyerType }}</span
                  >
                  <span class="ml5 fz14 z3">
                    {{ ticket.ticketCode }}
                  </span> -->
                  </div>
                  <div>
                    <span class="ml5 fz14 z3" v-if="ticket.ticketCode==activeTicketName">
                      折叠
                    </span>
                    <span class="ml5 fz14 z3" v-else>
                      展开
                    </span>
                  </div>
                </div>
              </template>
              <div class="cen">
                <img :src="ticket.qrcode" class="kjnmjmxeert" />
                <p>
                  <!-- <span style="color: red"
                    >凭预约时二代身份证，可直接检票入馆</span
                  > -->
                  <span class="ml5 fz14 z3">{{ getTouristName( ticket.ticketId) }}{{ ticket.ticketCode }}</span>
                </p>
                <p v-if="ticket.completed">已用完</p>
                <p v-else-if="ticket.used">已用</p>
              </div>
              <div style="color:red;">
                <p class="fz14 cen">
                  17:00停止预约，停止入场（暑假期间：17:30停止预约，停止入场）。
                </p>
              </div>
            </van-collapse-item>
          </van-collapse>
        </div>
        <!-- 预约信息 -->
        <div class="pd mt20">
          <div class="kkjhnscobox yj4 ov pr sdfsdtywer pl10 pm15">
            <span
              v-if="orderInfo.orderStatusName"
              class="diannxjeerr cf fz17"
              >{{ orderInfo.orderStatusName }}</span
            >
            <p class="fz16 z3 mt10">预约信息</p>
            <div class="btm mt10">
              <div class="mt10">
                <span class="pr f_b">
                  <i class="f_i binknxerrt"></i>
                  <span class="kkmnmxerert">参观时段</span>
                </span>
                <span class="ml10 fz14 z6"
                  >{{ orderInfo.travelDate }} {{ orderInfo.changCiSTime && orderInfo.changCiETime ? orderInfo.changCiSTime + "-" + orderInfo.changCiETime : "" }}</span
                >
              </div>
              <!-- <div class="mt10">
                <span class="pr f_b">
                  <i class="f_i binknxerrt"></i>
                  <span class="kkmnmxerert">参观人数</span>
                </span>
                <span class="ml10 fz14 z6">{{ orderInfo.personNum }} </span>
              </div> -->
              <div class="mt10">
                <span class="pr f_b">
                  <i class="f_i binknxerrt"></i>
                  <span class="kkmnmxerert">参观人数</span>
                </span>
                <span class="ml10 fz14 z6">{{ orderInfo.totalNum }} </span>
              </div>
              <div class="mt10">
                <span class="pr f_b">
                  <i class="f_i binknxerrt"></i>
                  <span class="kkmnmxerert">预约区域</span>
                </span>
                <span class="ml10 fz14 z6">{{
                  orderInfo.tickets[0].ticketTypeName
                }}</span>
              </div>
              <div class="mt10" v-if="orderInfo.arrivalTime">
                <span class="pr f_b">
                  <i class="f_i binknxerrt"></i>
                  <span class="kkmnmxerert">讲解时间</span>
                </span>
                <span class="ml10 fz14 z6">{{
                  orderInfo.arrivalTime
                }}</span>
              </div>
              <!-- <div class="mt10">
                        <span class="pr f_b">
                            <i class="f_i binknxerrt"></i>
                            <span class="kkmnmxerert">使用方法</span>
                        </span>
                        <span class="ml10 fz14 z6"  v-if="orderInfo.keYuanTypeName=='外宾' || orderInfo.waiBinFlag || buyerType==2">凭一维码到现场自助设备核验取票</span>
                        <span class="ml10 fz14 z6"  v-else>凭二维码检票入馆</span>
                    </div> -->
            </div>
          </div>
        </div>
        <!-- 参观人信息 -->
        <div class="pd mt20">
          <div class="pd sdfsdtywer pm20" v-if="orderInfo.tourists.length > 0">
            <p class="fz16 z3 mt10">参观人信息</p>
            <div
              v-for="(tourist, index) in orderInfo.tourists"
              :key="index"
              class="btm mt10"
            >
              <div class="mt10">
                <span class="pr f_b">
                  <i class="f_i binknxerrt"></i>
                  <span class="kkmnmxerert">姓 名 </span>
                </span>
                <span class="ml10 fz14 z6">{{ tourist.name }}</span>
              </div>
              <div class="mt10" v-if="tourist.certNo">
                <span class="pr f_b">
                  <i class="f_i binknxerrt"></i>
                  <span class="kkmnmxerert">证件类型 </span>
                </span>
                <span class="ml10 fz14 z6">{{ tourist.certTypeName }}</span>
              </div>
              <div class="mt10" v-if="tourist.certNo">
                <span class="pr f_b">
                  <i class="f_i binknxerrt"></i>
                  <span class="kkmnmxerert">证件号码 </span>
                </span>
                <span class="ml10 fz14 z6">{{
                  encryption(tourist.certNo)
                }}</span>
              </div>
              <div class="mt10" v-if="!tourist.certNo">
                <span class="pr f_b">
                  <i class="f_i binknxerrt"></i>
                  <span class="kkmnmxerert">年龄 </span>
                </span>
                <span class="ml10 fz14 z6">{{ tourist.age }}</span>
              </div>
              <!-- <div class="mt10" v-if="!tourist.certNo">
                    <span class="pr f_b">
                        <i class="f_i binknxerrt"></i>
                        <span class="kkmnmxerert">出生日期 </span>
                    </span>
                    <span class="ml10 fz14 z6">{{tourist.birthday}}</span>
                </div> -->
            </div>
          </div>
        </div>
        <!-- 订单信息 -->
        <div class="pd mt20">
          <div class="pd sdfsdtywer pm20">
            <p class="fz16 z3 mt10">订单信息</p>
            <div class="btm mt10">
              <div class="mt10">
                <span class="pr f_b">
                  <i class="f_i binknxerrt"></i>
                  <span class="kkmnmxerert">预约时间 </span>
                </span>
                <span class="ml10 fz14 z6">{{ orderInfo.cTime }}</span>
              </div>
              <div class="mt10">
                <span class="pr f_b">
                  <i class="f_i binknxerrt"></i>
                  <span class="kkmnmxerert">订单编号 </span>
                </span>
                <span class="ml10 fz14 z6">{{ orderInfo.listNo }}</span>
              </div>
              <div v-if="orderInfo.contact.contactMobile" class="mt10">
                <span class="pr f_b">
                  <i class="f_i binknxerrt"></i>
                  <span class="kkmnmxerert">联系电话 </span>
                </span>
                <span class="ml10 fz14 z6">{{ orderInfo.contact.contactMobile }}</span>
              </div>
              <div v-if="orderInfo.plateNumbers && orderInfo.plateNumbers.length > 0">
                <div class="mt10" v-for="(plateNumber, index) in orderInfo.plateNumbers" :key="index">
                  <span class="pr f_b">
                    <i class="f_i binknxerrt"></i>
                    <span class="kkmnmxerert">车牌号{{ index + 1 }}</span>
                  </span>
                  <span class="ml10 fz14 z6"
                    >{{ plateNumber.licensePlateNumber }}
                    {{ plateNumber.carTypeName }}</span
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="orderInfo.allowCancel" style="position:sticky;left:0;bottom:64px;width:100%;z-index:1000">
        <div style="float:left; width:50%; background: #fff;" class="pt10 pm10">
          <div class=" cen">
            <van-button type="primary" @click="onCancel" class="w80">取消</van-button>
          </div>
        </div>
        <div style="float:left; width:50%; background: #fff;" class="pt10 pm10">
          <div class=" cen">
            <van-button
              type="primary"
              class="w80"
              :loading="changeLoading"
              style="background: #6da0a9; border-color: #6da0a9;"
              @click="onChange"
              >改签</van-button
            >
          </div>
        </div>
      </div>

      <!-- <div v-if="orderInfo.allowCancel" class="dsfsdtywwer cen">
          <van-button type="primary"  @click="onCancel"
            class="w40"
            >取消</van-button
          >&nbsp;&nbsp;&nbsp;&nbsp;
          <van-button
            type="primary"
            class="w40"
            :loading="changeLoading"
            style="background: #6da0a9; border-color: #6da0a9"
            @click="onChange"
            >改签</van-button
          >
      </div> -->
    </div>

    <van-popup
      v-model="showChangCi.show"
      position="bottom"
      :style="{ position: 'sticky', height: 'calc(100vh)' }"
    >
      <div v-if="!showOrderInfo" class="pd row navBar1">
        <p class="col">
          <img src="../assets/img/logo.png" class="loginnhjer cz" />
        </p>
        <span class="cf fz15" @click="showChangCi.show = false">关闭</span>
      </div>
      <div class="pd mt60 pm20">
        <p class="fz16 z3 mt10">订单信息</p>
        <div class="mt10">
          <span class="pr f_b">
            <i class="f_i binknxerrt"></i>
            <span class="kkmnmxerert">参观日期 </span>
          </span>
          <span class="ml10 fz14 z6">{{ orderInfo.travelDate }}</span>
        </div>
        <div class="mt10">
          <span class="pr f_b">
            <i class="f_i binknxerrt"></i>
            <span class="kkmnmxerert">验票时段 </span>
          </span>
          <span class="ml10 fz14 z6">
            {{ orderInfo.changCiSTime }}-{{ orderInfo.changCiETime }}</span
          >
        </div>
        <div class="mt10">
          <span class="pr f_b">
            <i class="f_i binknxerrt"></i>
            <span class="kkmnmxerert">游客人数 </span>
          </span>
          <span class="ml10 fz14 z6">{{ orderInfo.personNum }}</span>
        </div>
      </div>
      <div class="pd mt10 mb10 btm">
        <p class="mt10 fz16">
          请重新选择验票时段
        </p>
        <van-grid
          v-if="
            !wxLastBookTime && changCis[0] && changCis[0].children.length > 0
          "
          :border="false"
          :column-num="2"
          style="margin-right: -10px"
        >
          <van-grid-item
            v-for="changCi in changCis[0].children"
            :key="changCi.value"
            :name="changCi.value"
          >
            <div
              class="fgdrtwerab"
              style="border-radius: 25px;"
              :class="[newChangCiId == changCi.value ? 'act' : '']"
              @click="changCiClick(changCi)"
            >
              <p class="fz17 z6">{{ changCi.text }}</p>
              <p class="zts fz12">{{ "(余票:" + changCi.surplusNum + ")" }}</p>
            </div>
          </van-grid-item>
        </van-grid>
        <div v-else class="panel-content">
          <div class=" pd" style="color:red; line-height:50px;">
            当前没有参观时段可供改签
          </div>
        </div>
        <div class="pt30 fz13">
          <div style="float:left">
            <van-icon name="warning" color="#a9716d" size="20px" />
          </div>
          <div style="float:left;">
            &nbsp;&nbsp;欲选择其他参观日入场，取消订单后另行预约
          </div>
        </div>
      </div>
      <div :disabled="orderInfo.allowCancel" class="dsfsdtywwer cen mt50">
        <van-button
          type="primary"
          @click="changCiChange"
          :loading="changCiChangeLoading"
          class="w100"
          >订单改签</van-button
        >
      </div>
    </van-popup>
  </div>
</template>

<script>
import vueBarcode from "vue-barcode";
import QRCode from "qrcode";
import orderService from "@/services/orderService.js";
import dateHelper from "@/utils/dateHelper.js";
import scenicService from "./../services/scenicService.js";
import { aesDecrypt } from '@/utils/crypto';
// import explainerService from "@/services/explainerService.js";

export default {
  name: "order-info",
  props: {
    listNo: {
      type: String,
    },
    showNavbar: {
      type: Boolean,
      default: false,
    },
    showChangCi: {
      type: Object,
      default: function() {
        return { show: false };
      },
    },
    showOrderInfo: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    vueBarcode,
  },
  data() {
    return {
      loading: false,
      dataLoaded: false,
      activeTicketName: "",
      orderInfo: {
        tickets: [{ ticketTypeName: "" }],
        tourists: [],
        contact: { contactMobile: "" },
      },
      buyerType: "",
      wxLastBookTime: false,
      newChangCiId: "",
      changCis: [],
      loadingExplainer: false,
      explainers: [],
      changeLoading: false,
      changCiChangeLoading: false,
    };
  },
  computed: {
    keYuan() {
      return `${this.orderInfo.keYuanTypeName}，${this.orderInfo.areaName}`;
    },
    font_size() {
      var windowWidth = document.documentElement.clientWidth;
      var fontSize = (windowWidth - 40) / 20;
      if (fontSize > 32) fontSize = 32;
      return "font-size:" + fontSize + "px";
    },
  },
  methods: {
    async ticketChangCiChanges() {
      await orderService.ticketChangCiChangesAsync(
        this.listNo,
        this.newChangCiId,
        this.orderInfo.tickets[0].ticketTypeId
      );
      this.showChangCi.show = false;
      let order = await orderService.getOrderInfoForMobileAsync(this.listNo);
      await this.initOrder(order);
      this.$toast("操作成功");
    },
    async initOrder(order) {
      if (order) {
        this.activeTicketName = "";
        if (
          order.tickets[0].buyerType == "团体" ||
          order.tickets[0].buyerType == "接待"
        ) {
          //团体
          this.buyerType = 1;
        } else if (
          order.tourists.length > 0 &&
          order.tourists.find((t) => {
            return t.certTypeId != 5 && !t.birthday;
          })
        ) {
          //非团体非实名认证
          this.buyerType = 2;
        }
        if (this.buyerType == 1 || this.buyerType == 2) {
          order.tickets[0].qrcode = await this.generateQRCode(this.listNo);
          this.activeTicketName = order.listNo;
        } else {
          for (let i = 0; i < order.tickets.length; i++) {
            let ticket = order.tickets[i];
            //if (!ticket.completed) {
            ticket.qrcode = await this.generateQRCode(ticket.ticketCode);
            //}
          }
          this.activeTicketName = order.tickets[0].ticketCode;
        }
        this.orderInfo = order;
      }
    },
    async changCiChange() {
      this.changCiChangeLoading = true;
      if (!this.newChangCiId) {
        this.$toast("请选择参观时段！");
        this.changCiChangeLoading = false;
      } else {
        try {
          await this.ticketChangCiChanges();
        }
        finally{
          this.changCiChangeLoading = false;
        }
      }
    },
    changCiClick(changCi) {
      this.newChangCiId = changCi.value;
    },
    encryption(val) {
      if (val.length >= 4) {
        return val.substr(0, val.length - 4) + "****";
      } else {
        return val;
      }
    },
    toHome() {
      this.$router.push("/");
    },
    async onAccordionChange(index) {
      if (index === "" || this.orderInfo.tickets[index].qrcode) {
        return;
      }

      let ticket = this.orderInfo.tickets[index];
      // if (!ticket.completed) {
      ticket.qrcode = await this.generateQRCode(this.orderInfo.tickets[index].ticketCode);
      // }
    },
    async getChangCis(travelDate, groundId) {
      if (!travelDate || !groundId) {
        return;
      }

      if (dateHelper.validEqualDateNow(travelDate)) {
        this.wxLastBookTime = await scenicService.validExceedWxLastBookTime();
        if (this.wxLastBookTime) {
          return;
        }
      }

      this.newChangCiId = "";
      
      //场次
      var changCis = await scenicService.getGroundChangCiItemsAsync({
        groupFlag: !(this.orderInfo.customerId === null || this.orderInfo.customerId === ""),
        travelDate: travelDate,
        groundId: groundId,
      });
      var orderChangCiId = this.orderInfo.changCiId;
      changCis = changCis.filter(function(elem) {
        return elem.changCiId != orderChangCiId;
      });
      this.changCis = [
        {
          text: "场次",
          children: changCis.map((c) => {
            return {
              value: c.changCiId,
              text: c.sTime + "-" + c.eTime,
              disabled: c.disabled,
              surplusNum: c.surplusNum <= 0 ? "0" : c.surplusNum,
              packingLotId: c.packingLotId,
              carSpacingNum: c.carSpacingNum,
              busSpacingNum: c.busSpacingNum,
            };
          }),
        },
      ];

      //讲解
      // try {
      //   this.loadingExplainer = true;
      //   this.explainers = await explainerService.getSchedulingsAsync({
      //     Date: travelDate,
      //     TicketTypeId: groundId,
      //   });
      // } finally {
      //   this.loadingExplainer = false;
      // }
    },
    async onChange() {
      this.changeLoading = true;
      await this.getChangCis(
        this.orderInfo.travelDate,
        this.orderInfo.tickets[0].ticketTypeId
      );
      this.showChangCi.show = true;
      this.changeLoading = false;
    },
    async onCancel() {
      try {
        this.loading = true;
        await this.$dialog.confirm({ title: "确定取消预约？" });
        await this.cancelOrder();
      } catch (err) {
        return;
      } finally {
        this.loading = false;
      }
    },
    async cancelOrder() {
      let response = await orderService.cancelOrderAsync(this.listNo);
      if (response.success) {
        this.$toast("取消成功");
        await this.getOrderInfo();
      }
    },
    async getOrderInfo() {
      try {
        this.loading = true;
        this.dataLoaded = false;
        this.showChangCi.show = false;
        let order = await orderService.getOrderInfoForMobileAsync(this.listNo);
        await this.initOrder(order);
        this.loading = false;
        this.dataLoaded = true;
      } catch (err) {
        return;
      } finally {
        this.loading = false;
        this.dataLoaded = true;
      }
    },
    async generateQRCode(text) {
      try {
        return await QRCode.toDataURL(text, { 
                                              type: "image/png", //类型
                                              quality: 0.5, //图片质量A Number between 0 and 1
                                              width: 120, //高度
                                              height: 120, //宽度
                                              errorCorrectionLevel: "L", //容错率
                                              margin: 1, //外边距
                                              color: {
                                                dark: "#000000", //前景色
                                                light: "#ffffff" //背景色
                                              }
        });
      } catch (err) {
        this.$toast(err);
      }
    },
    getTouristName(ticketId){
      if(this.orderInfo.tourists.length>0){
        var tourist = this.orderInfo.tourists.find(o=>{return o.ticketId == ticketId});
        if(tourist){
          return tourist.name +"："
        }else{
          return "";
        }
      }else{
         return "";
      }
      
    },
    getDecryptCode(code){
      return aesDecrypt(code);
    }
  },
  watch: {
    listNo: async function() {
      this.buyerType = "";
      await this.getOrderInfo();
    },
  },
  async created() {
    this.buyerType = "";
    await this.getOrderInfo();
  },
};
</script>

<style lang="scss">
.jjnnjxer {
  width: 17px;
  height: 17px;
  background: #a9716d;
  color: #fff;
  display: inline-block;
  border-radius: 4px;
  text-align: center;
  line-height: 17px;
}
.check {
  display: flex;
  justify-content: space-between;
}
.sdfgdgttwe {
  height: 17px;
  line-height: 17px;
  background: #6da0a9;
  padding: 0 4px;
}

.navBar1 {
  height: 44px;
  line-height: 44px;
  background: #603531;
  position: fixed;
  width: 100%;
  left: 0;
  top: 0;
  z-index: 30000;
}
</style>
